import { Col, Dropdown, Form, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Main from '../Main';
import Download from '../MainSection/Download/Download';
import '../../assets/css/dashboardlibrary.scss';
import threedots from '../../assets/images/three-dot-img.svg';
import DashboardLibraryImg1 from '../../assets/images/dashboard-library-1.png';
import DashboardLibraryImg2 from '../../assets/images/dashboard-library-2.png';
import DashboardLibraryImg3 from '../../assets/images/dashboard-library-3.png';
import DashboardLibraryImg4 from '../../assets/images/dashboard-library-4.png';
import DashboardLibraryImg5 from '../../assets/images/dashboard-library-5.png';
import mobileImg from '../../assets/images/mobile-img.svg';
import contentShow from '../../assets/images/content-show.svg';
import ShareModal from './ShareModal';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardConfig from '../PowerBi/DashboardConfig';
import { useDispatch, useSelector } from 'react-redux';
import { loadSettingsDynamicDashboard, postDefaultDashboardDatas } from '../../redux/action';
import * as HeaderAuthentication from '../HeaderAuthentication'
import { ADDED_BY_ID } from '../../Constants';
import { Accordion, Card, Button } from "react-bootstrap";

// const DashboardLibrary = () => {
//     const navigate = useNavigate(); // Initialize useNavigate
//     const dispatch = useDispatch();
//     const { getDynamicDashboardData } = useSelector((state) => state.data);

//     // Array holding the different labels, image paths, and their corresponding routes
//     const dashboardItems = [
//         { label: 'Customer', imgSrc: DashboardLibraryImg1, route: '/dashboard' },
//         { label: 'Licence', imgSrc: DashboardLibraryImg2, route: '/licenceDashboard' },
//         { label: 'Attendance', imgSrc: DashboardLibraryImg3, route: '/attendanceDashboard' },
//         { label: 'Complaint / Escalation', imgSrc: DashboardLibraryImg4, route: '/complaintDashboard' },
//         { label: 'SLA', imgSrc: DashboardLibraryImg5, route: '/slaDashboard' },
//     ];

//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [mobileViewState, setMobileViewState] = useState({});
//     const [loading, setLoading] = useState(true);

//     const fetchDynamicDashboards = () => {
//         dispatch(loadSettingsDynamicDashboard(setLoading));
//     }
//     useEffect(() => {
//         fetchDynamicDashboards();
//     }, [])

//     const handleOpenModal = () => {
//         setIsModalOpen(true);
//     };

//     const handleCloseModal = () => {
//         setIsModalOpen(false);
//     };

//     const handleImageClick = (dashboard, type) => {
//         if (dashboard.DashboardCategoryName === "System Dashboard") {
//             // Open link based on visibility preference
//             const targetLink = dashboard.DisplayPublicLink ? dashboard.PublicLink : dashboard.SecuredLink;
//             window.open(targetLink, "_blank"); // Open in new tab
//         } else if (dashboard.DashboardLibraryID) {
//             // Navigate to Power BI dashboard by ID
//             navigate(`/powerbi-dashboard/${dashboard.DashboardLibraryID}`, {
//                 state: { viewType: type } // Pass type via navigation);
//             })
//         }
//     };

//     const toggleMobileView = (dashboardId) => {
//         setMobileViewState((prevState) => ({
//             ...prevState,
//             [dashboardId]: !prevState[dashboardId],
//         }));
//     };
//     const handleBack = () => {
//         navigate(-1);
//     };

//     // Group dashboards by DashboardCategoryName
//     const groupedDashboards = getDynamicDashboardData?.reduce((acc, item) => {
//         if (!acc[item.DashboardCategoryName]) {
//             acc[item.DashboardCategoryName] = [];
//         }
//         acc[item.DashboardCategoryName].push(item);
//         return acc;
//     }, {});

//     const handleRadioChange = (selectedDashboard, linkType) => {
//         const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
//         let CustomerID = signInDetails[0]?.CompanyID; // Use CompanyID for all user types

//         const data = {
//             CompanyID: CustomerID,
//             DashboardLibraryID: selectedDashboard.DashboardLibraryID,
//             LinkType: linkType === 'public' ? 'Public' : 'Secured',
//             AddedByID: ADDED_BY_ID, // Pass UserID as the one who added it
//         };

//         let requestOption = {
//             method: "POST",
//             mode: "cors",
//             headers: HeaderAuthentication.postExcomatixAuth,
//             body: JSON.stringify(data),
//         };

//         dispatch(postDefaultDashboardDatas(requestOption, fetchDynamicDashboards));
//         console.log("Submitting Data:", data);
//     };

//     const handleMobileViewChange = (selectedDashboard, linkType, index) => {
//         const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
//         let CustomerID = signInDetails[0]?.CompanyID;

//         const data = {
//             CompanyID: CustomerID,
//             MobileDashboardLibraryID: selectedDashboard.DashboardLibraryID,
//             MobileDashboardLinkType: linkType === 'public' ? 'Public' : 'Secured',
//             AddedByID: ADDED_BY_ID
//         };

//         const requestOption = {
//             method: "POST",
//             mode: "cors",
//             headers: HeaderAuthentication.postExcomatixAuth,
//             body: JSON.stringify(data),
//         };
//         console.log(data, 'data')
//         // dispatch(postDefaultDashboardDatas(requestOption, fetchDynamicDashboards));
//         toggleMobileView(selectedDashboard.DashboardLibraryID);
//     };

//     return (
//         <div className="customer-management-container">
//             <Main>
//                 <div className='components-download-container'>
//                     <Download
//                         showBackButton={true}
//                         moduleName="Dashboard Library"
//                         onBackClick={handleBack}
//                     />
//                     <div>
//                         {/* Iterate over grouped dashboards */}
//                         <div>
//                             {/* Render System Dashboard separately */}
//                             {groupedDashboards && groupedDashboards["System Dashboard"] && (
//                                 <div>
//                                     <Row className="dashboard-library-container" style={{ display: 'flex', flexWrap: 'wrap' }}>
//                                         <Col md={12}>
//                                             <label className="category-label p-0">System Dashboard</label>
//                                         </Col>

//                                         {groupedDashboards["System Dashboard"].map((item, itemIndex) => (
//                                             <Col md={3} key={`system-dashboard-${itemIndex}`} className="dashboard-library-col">
//                                                 <div className="dashboard-library-div">
//                                                     <Form.Group>
//                                                         <Form.Check
//                                                             type="radio"
//                                                             id={`radio-system-${itemIndex}`}
//                                                             name="radioGroup"
//                                                             onChange={() => handleRadioChange(item, 'public')}
//                                                             checked={item.IsDefault}
//                                                         />

//                                                     </Form.Group>
//                                                     <p style={{ textWrap: "nowrap", padding: "0 5px" }}>
//                                                         {item.DisplayPublicLink ? '(P)' : '(S)'} &nbsp;{item.DashboardLibraryName}
//                                                     </p>
//                                                     <p>
//                                                         {item.label}&nbsp;
//                                                         {mobileViewState[item.DashboardLibraryID] && <img src={mobileImg} alt="Mobile View" />}
//                                                     </p>
//                                                     <Dropdown align="end" className="dashboard-library-dropdown">
//                                                         <Dropdown.Toggle as="div" className="dropdown-toggle">
//                                                             <img src={threedots} alt="options" />
//                                                         </Dropdown.Toggle>
//                                                         <Dropdown.Menu>
//                                                             <Dropdown.Item onClick={() => handleMobileViewChange(item, item.DisplayPublicLink ? 'public' : 'secured')}>
//                                                                 {mobileViewState[item.DashboardLibraryID] ? 'Remove Mobile View' : 'Set Mobile View'}
//                                                             </Dropdown.Item>
//                                                             <Dropdown.Item onClick={handleOpenModal}>Share</Dropdown.Item>
//                                                         </Dropdown.Menu>
//                                                     </Dropdown>
//                                                 </div>

//                                                 <hr />

//                                                 <div className="dashboard-library-img">
//                                                     <a
//                                                         href={item.DisplayPublicLink ? item.PublicLink : item.SecuredLink}
//                                                         target="_blank"
//                                                         rel="noopener noreferrer"
//                                                     >
//                                                         <img
//                                                             src={item.FilePath || (item.DisplayPublicLink ? DashboardLibraryImg1 : DashboardLibraryImg2)}
//                                                             alt={item.DashboardLibraryName}
//                                                             className="library-img"
//                                                             onClick={() => handleImageClick(item)}
//                                                         />
//                                                     </a>
//                                                     <OverlayTrigger
//                                                         trigger="hover"
//                                                         placement="top"
//                                                         overlay={
//                                                             <Tooltip id={`tooltip-system-${itemIndex}`} className="dashboard-library-tooltip">
//                                                                 {item.Description}
//                                                             </Tooltip>
//                                                         }
//                                                     >
//                                                         <img src={contentShow} alt="content icon" className="content-icon" style={{ cursor: 'pointer' }} />
//                                                     </OverlayTrigger>
//                                                 </div>
//                                             </Col>
//                                         ))}
//                                     </Row>
//                                     <hr style={{ border: "1px solid black" }} />
//                                 </div>
//                             )}

//                             {/* Render other dashboards */}
//                             {groupedDashboards &&
//                                 Object.entries(groupedDashboards).map(([categoryName, dashboards], index, array) => {
//                                     if (categoryName === "System Dashboard") return null;

//                                     return (
//                                         <div key={`category-${index}`}>
//                                             <Row className="dashboard-library-container" style={{ display: 'flex', flexWrap: 'wrap' }}>
//                                                 <Col md={12}>
//                                                     <label className="category-label p-0">{categoryName}</label>
//                                                 </Col>

//                                                 {dashboards.map((item, itemIndex) => (
//                                                     <div key={`dashboard-${itemIndex}`} className="d-flex gap-4 pb-2">
//                                                         {item.DisplayPublicLink && (
//                                                             <Col md={3} className="dashboard-library-col">
//                                                                 <div className="dashboard-library-div">
//                                                                     <Form.Group>
//                                                                         <Form.Check
//                                                                             type="radio"
//                                                                             id={`radio-public-${itemIndex}`}
//                                                                             name={`radioGroup-${item.DashboardLibraryID}`}
//                                                                             onChange={() => handleRadioChange(item, 'public')}
//                                                                             checked={item.IsDefault && item.LinkType === 'Public'}
//                                                                         />
//                                                                     </Form.Group>
//                                                                     <p style={{ textWrap: "nowrap", padding: "0 5px" }}>(P) {item.DashboardLibraryName}</p>
//                                                                     <p>
//                                                                         {item.label}&nbsp;
//                                                                         {mobileViewState[item.DashboardLibraryID] && <img src={mobileImg} alt="Mobile View" />}
//                                                                     </p>
//                                                                     <Dropdown align="end" className="dashboard-library-dropdown">
//                                                                         <Dropdown.Toggle as="div" className="dropdown-toggle">
//                                                                             <img src={threedots} alt="options" />
//                                                                         </Dropdown.Toggle>
//                                                                         <Dropdown.Menu>
//                                                                             <Dropdown.Item onClick={() => handleMobileViewChange(item, 'public', itemIndex)}>
//                                                                                 {mobileViewState[itemIndex] ? 'Remove Mobile View' : 'Set Mobile View'}
//                                                                             </Dropdown.Item>
//                                                                             <Dropdown.Item onClick={handleOpenModal}>Share</Dropdown.Item>
//                                                                         </Dropdown.Menu>
//                                                                     </Dropdown>
//                                                                 </div>
//                                                                 <hr />
//                                                                 <div className="dashboard-library-img">
//                                                                     {/* <a href={item.PublicLink} target="_blank" rel="noopener noreferrer"> */}
//                                                                     <img
//                                                                         src={item.FilePath || DashboardLibraryImg1}
//                                                                         alt={item.DashboardLibraryName}
//                                                                         className="library-img"
//                                                                         onClick={() => handleImageClick(item)}
//                                                                     />
//                                                                     {/* </a> */}
//                                                                     <OverlayTrigger
//                                                                         trigger="hover"
//                                                                         placement="top"
//                                                                         overlay={
//                                                                             <Tooltip id={`tooltip-public-${itemIndex}`} className="dashboard-library-tooltip">
//                                                                                 {item.Description}
//                                                                             </Tooltip>
//                                                                         }
//                                                                     >
//                                                                         <img src={contentShow} alt="content icon" className="content-icon" style={{ cursor: 'pointer' }} />
//                                                                     </OverlayTrigger>
//                                                                 </div>
//                                                             </Col>
//                                                         )}

//                                                         {item.DisplaySecuredLink && (
//                                                             <Col md={3} className="dashboard-library-col">
//                                                                 <div className="dashboard-library-div">
//                                                                     <Form.Group>
//                                                                         <Form.Check
//                                                                             type="radio"
//                                                                             id={`radio-secured-${itemIndex}`}
//                                                                             name={`radioGroup-${item.DashboardLibraryID}`}
//                                                                             onChange={() => handleRadioChange(item, 'secured')}
//                                                                             checked={item.IsDefault && item.LinkType === 'Secured'}
//                                                                         />
//                                                                     </Form.Group>
//                                                                     <p style={{ textWrap: "nowrap", padding: "0 3px" }}>(S) {item.DashboardLibraryName}</p>
//                                                                     <p>
//                                                                         {item.label}&nbsp;
//                                                                         {mobileViewState[itemIndex] && <img src={mobileImg} alt="Mobile View" />}
//                                                                     </p>
//                                                                     <Dropdown align="end" className="dashboard-library-dropdown">
//                                                                         <Dropdown.Toggle as="div" className="dropdown-toggle">
//                                                                             <img src={threedots} alt="options" />
//                                                                         </Dropdown.Toggle>
//                                                                         <Dropdown.Menu>
//                                                                             <Dropdown.Item onClick={() => handleMobileViewChange(item, 'secured', itemIndex)}>
//                                                                                 {mobileViewState[itemIndex] ? 'Remove Mobile View' : 'Set Mobile View'}
//                                                                             </Dropdown.Item>
//                                                                             <Dropdown.Item onClick={handleOpenModal}>Share</Dropdown.Item>
//                                                                         </Dropdown.Menu>
//                                                                     </Dropdown>
//                                                                 </div>
//                                                                 <hr />
//                                                                 <div className="dashboard-library-img">
//                                                                     {/* <a href={item.SecuredLink} target="_blank" rel="noopener noreferrer"> */}
//                                                                     <img
//                                                                         src={item.FilePath || DashboardLibraryImg2}
//                                                                         alt={item.DashboardLibraryName}
//                                                                         className="library-img"
//                                                                         onClick={() => handleImageClick(item, 'secured')}
//                                                                     />
//                                                                     {/* </a> */}
//                                                                     <OverlayTrigger
//                                                                         trigger="hover"
//                                                                         placement="top"
//                                                                         overlay={
//                                                                             <Tooltip id={`tooltip-secured-${itemIndex}`} className="dashboard-library-tooltip">
//                                                                                 {item.Description}
//                                                                             </Tooltip>
//                                                                         }
//                                                                     >
//                                                                         <img src={contentShow} alt="content icon" className="content-icon" style={{ cursor: 'pointer' }} />
//                                                                     </OverlayTrigger>
//                                                                 </div>
//                                                             </Col>
//                                                         )}
//                                                     </div>
//                                                 ))}
//                                             </Row>
//                                             <hr style={{ border: "1px solid black" }} />
//                                         </div>
//                                     );
//                                 })}
//                         </div>

//                     </div>
//                 </div>
//             </Main>
//             {
//                 isModalOpen && <ShareModal
//                     open={isModalOpen}
//                     handleClose={handleCloseModal}
//                 />
//             }
//         </div>
//     );
// };

// export default DashboardLibrary;


const DashboardLibrary = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { getDynamicDashboardData } = useSelector((state) => state.data);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [mobileViewState, setMobileViewState] = useState({});
    const [loading, setLoading] = useState(true);
    console.log(ADDED_BY_ID, 'ADDED_BY_ID')
    const fetchDynamicDashboards = () => {
        dispatch(loadSettingsDynamicDashboard(setLoading));
    };

    useEffect(() => {
        fetchDynamicDashboards();
    }, []);

    const handleOpenModal = () => setIsModalOpen(true);
    const handleCloseModal = () => setIsModalOpen(false);

    const toggleMobileView = (dashboardId, linkType) => {
        const key = `${dashboardId}-${linkType}`;
        setMobileViewState((prevState) => ({
            ...prevState,
            [key]: !prevState[key],
        }));
    };

    const handleBack = () => {
        navigate(-1);
    };

    const groupedDashboards = getDynamicDashboardData?.reduce((acc, item) => {
        if (!acc[item.DashboardCategoryName]) {
            acc[item.DashboardCategoryName] = [];
        }
        acc[item.DashboardCategoryName].push(item);
        return acc;
    }, {});

    const handleImageClick = (dashboard, type) => {
        if (dashboard.DashboardCategoryName === "System Dashboard") {
            const targetLink = dashboard.DisplayPublicLink ? dashboard.PublicLink : dashboard.SecuredLink;
            window.open(targetLink, "_blank");
        } else if (dashboard.DashboardLibraryID) {
            navigate(`/powerbi-dashboard/${dashboard.DashboardLibraryID}`, {
                state: { viewType: type }
            });
        }
    };

    const handleRadioChange = (selectedDashboard, linkType) => {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = signInDetails[0]?.CompanyID;

        const data = {
            CompanyID: CustomerID,
            DashboardLibraryID: selectedDashboard.DashboardLibraryID,
            LinkType: linkType === 'public' ? 'Public' : 'Secured',
            AddedByID: ADDED_BY_ID,
            UpdateType: "Web"
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        dispatch(postDefaultDashboardDatas(requestOption, fetchDynamicDashboards));
    };

    // const handleMobileViewChange = (selectedDashboard, linkType) => {
    //     const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    //     let CustomerID = signInDetails[0]?.CompanyID;

    //     const data = {
    //         CompanyID: CustomerID,
    //         MobileDashboardLibraryID: selectedDashboard.DashboardLibraryID,
    //         MobileDashboardLinkType: linkType === 'public' ? 'Public' : 'Secured',
    //         AddedByID: ADDED_BY_ID
    //     };

    //     const requestOption = {
    //         method: "POST",
    //         mode: "cors",
    //         headers: HeaderAuthentication.postExcomatixAuth,
    //         body: JSON.stringify(data),
    //     };

    //     // dispatch(postDefaultDashboardDatas(requestOption, fetchDynamicDashboards));
    //     toggleMobileView(selectedDashboard.DashboardLibraryID, linkType);
    //     console.log(data, 'data')
    // };

    const handleMobileViewChange = (selectedDashboard, linkType) => {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
        let CustomerID = signInDetails[0]?.CompanyID;

        const key = `${selectedDashboard.DashboardLibraryID}-${linkType}`;
        const isCurrentlySet = mobileViewState[key];

        const data = {
            CompanyID: CustomerID,
            MobileDashboardLibraryID: isCurrentlySet ? 0 : selectedDashboard.DashboardLibraryID,
            MobileDashboardLinkType: isCurrentlySet ? "" : (linkType === 'public' ? 'Public' : 'Secured'),
            AddedByID: ADDED_BY_ID,
            UpdateType: "Mobile"
        };

        const requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        dispatch(postDefaultDashboardDatas(requestOption, fetchDynamicDashboards));
        toggleMobileView(selectedDashboard.DashboardLibraryID, linkType);
        // console.log(data,'data')
    };

    useEffect(() => {
        if (getDynamicDashboardData?.length) {
            const initialState = {};

            getDynamicDashboardData.forEach((item) => {
                const key = `${item.DashboardLibraryID}-${item.MobLinkType.toLowerCase()}`;

                // Only set state for MobLinkType (Public or Secured)
                if (item.IsMobileDefault && item.MobLinkType) {
                    initialState[key] = true;
                }
            });

            setMobileViewState(initialState);
        }
    }, [getDynamicDashboardData]);

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Dashboard Library"
                        onBackClick={handleBack}
                    />
                    <div className='pt-3 pb-3'>
                        <Accordion defaultActiveKey="0" alwaysOpen>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>System Dashboards</Accordion.Header>
                                <Accordion.Body>
                                    {groupedDashboards?.["System Dashboard"] && (
                                        <>
                                            <Row className="dashboard-library-container" style={{ flexWrap: 'wrap' }}>
                                                {/* <Col md={12} className='p-2'>
                                                    <label className="category-label p-0">System Dashboards</label>
                                                </Col> */}
                                                {groupedDashboards["System Dashboard"].map((item) => {
                                                    const type = item.DisplayPublicLink ? "public" : "secured";
                                                    const key = `${item.DashboardLibraryID}-${type}`;
                                                    return (
                                                        <Col md={4} key={item.DashboardLibraryID} className='ps-1'>
                                                            <div className="dashboard-library-col">
                                                                <div className="dashboard-library-div">
                                                                    <Form.Group>
                                                                        <Form.Check
                                                                            type="radio"
                                                                            name="radioGroup"
                                                                            onChange={() => handleRadioChange(item, type)}
                                                                            checked={item.IsDefault}
                                                                        />
                                                                    </Form.Group>
                                                                    <p style={{ textWrap: "nowrap", padding: "0 5px" }}>
                                                                        {item.DisplayPublicLink ? '(P)' : '(S)'} {item.DashboardLibraryName}
                                                                    </p>
                                                                    <p>
                                                                        {item.label}&nbsp;
                                                                        {item.IsMobileDefault && mobileViewState[key] && <img src={mobileImg} alt="Mobile View" />}
                                                                    </p>
                                                                    {!item.IsMobileDefault && <Dropdown align="end" className="dashboard-library-dropdown">
                                                                        <Dropdown.Toggle as="div" className="dropdown-toggle">
                                                                            <img src={threedots} alt="options" />
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu>
                                                                            {!item.IsMobileDefault && (
                                                                                <Dropdown.Item onClick={() => handleMobileViewChange(item, type)}>
                                                                                    {mobileViewState[key] ? 'Remove Mobile View' : 'Set Mobile View'}
                                                                                </Dropdown.Item>)}
                                                                            {/* <Dropdown.Item onClick={handleOpenModal}>Share</Dropdown.Item> */}
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>}
                                                                </div>
                                                                {/* <hr /> */}
                                                                <div className="dashboard-library-img">
                                                                    <a href={item.DisplayPublicLink ? item.PublicLink : item.SecuredLink} target="_blank" rel="noopener noreferrer">
                                                                        <img
                                                                            src={item.FilePath || (item.DisplayPublicLink ? DashboardLibraryImg1 : DashboardLibraryImg2)}
                                                                            alt={item.DashboardLibraryName}
                                                                            className="library-img"
                                                                            onClick={() => handleImageClick(item)}
                                                                        />
                                                                    </a>
                                                                    <OverlayTrigger
                                                                        trigger="hover"
                                                                        placement="top"
                                                                        overlay={
                                                                            <Tooltip id={`tooltip-${item.DashboardLibraryID}`} className="dashboard-library-tooltip">
                                                                                {item.Description}
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <img src={contentShow} alt="content icon" className="content-icon" style={{ cursor: 'pointer' }} />
                                                                    </OverlayTrigger>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    );
                                                })}
                                            </Row>

                                        </>
                                    )}
                                </Accordion.Body>
                            </Accordion.Item>
                            {/* <hr style={{ border: "1px solid black" }} /> */}
                            {Object.entries(groupedDashboards || {}).map(([categoryName, dashboards], index) => {
                                if (categoryName === "System Dashboard") return null;
                                return (
                                    <div key={categoryName}>
                                        <Accordion.Item eventKey={(index + 1).toString()} key={categoryName}>
                                            <Accordion.Header>{categoryName}</Accordion.Header>
                                            <Accordion.Body>
                                                <Row className="dashboard-library-container" style={{ flexWrap: 'wrap' }}>
                                                    {/* <Col md={12} className='p-2 pt-0'>
                                                        <label className="category-label p-0">{categoryName}</label>
                                                    </Col> */}
                                                    {dashboards.map((item) =>
                                                        ["Public", "Secured"].map((type) => {
                                                            const displayFlag = type === "Public" ? item.DisplayPublicLink : item.DisplaySecuredLink;
                                                            if (!displayFlag) return null;
                                                            const lowerType = type.toLowerCase();
                                                            const key = `${item.DashboardLibraryID}-${lowerType}`;

                                                            return (
                                                                <Col md={4} key={key} className='ps-1'>
                                                                    <div className="dashboard-library-col">
                                                                        <div className="dashboard-library-div">
                                                                            <Form.Group>
                                                                                <Form.Check
                                                                                    type="radio"
                                                                                    name={`radioGroup-${item.DashboardLibraryID}`}
                                                                                    onChange={() => handleRadioChange(item, lowerType)}
                                                                                    checked={item.IsDefault && item.LinkType === type}
                                                                                />
                                                                            </Form.Group>
                                                                            {/* <p style={{ textWrap: "nowrap", padding: "0 3px" }}>
                                                                                ({type === "Public" ? "P" : "S"}) {item.DashboardLibraryName}
                                                                            </p> */}
                                                                            <p
                                                                                style={{
                                                                                    whiteSpace: "nowrap",
                                                                                    overflow: "hidden",
                                                                                    textOverflow: "ellipsis",
                                                                                    padding: "0 3px",
                                                                                    maxWidth: "250px" // adjust so it fits ~28 chars
                                                                                }}
                                                                                title={`(${type === "Public" ? "P" : "S"}) ${item.DashboardLibraryName}`}
                                                                            >
                                                                                ({type === "Public" ? "P" : "S"}) {item.DashboardLibraryName}
                                                                            </p>

                                                                            <p>
                                                                                {item.label}&nbsp;
                                                                                {item.IsMobileDefault && mobileViewState[key] && <img src={mobileImg} alt="Mobile View" />}
                                                                            </p>
                                                                            {item.IsMobileDefault === false && item.MobLinkType === "" && <Dropdown align="end" className="dashboard-library-dropdown">
                                                                                <Dropdown.Toggle as="div" className="dropdown-toggle">
                                                                                    <img src={threedots} alt="options" />
                                                                                </Dropdown.Toggle>
                                                                                <Dropdown.Menu>
                                                                                    {item.IsMobileDefault === false && item.MobLinkType === "" && (
                                                                                        <Dropdown.Item onClick={() => handleMobileViewChange(item, lowerType)}>
                                                                                            {mobileViewState[key] ? 'Remove Mobile View' : 'Set Mobile View'}
                                                                                        </Dropdown.Item>
                                                                                    )}
                                                                                    {/* <Dropdown.Item onClick={handleOpenModal}>Share</Dropdown.Item> */}
                                                                                </Dropdown.Menu>
                                                                            </Dropdown>}
                                                                        </div>
                                                                        {/* <hr /> */}
                                                                        <div className="dashboard-library-img">
                                                                            <img
                                                                                src={item.FilePath || (type === "Public" ? DashboardLibraryImg1 : DashboardLibraryImg2)}
                                                                                alt={item.DashboardLibraryName}
                                                                                className="library-img"
                                                                                onClick={() => handleImageClick(item, lowerType)}
                                                                            />
                                                                            <OverlayTrigger
                                                                                trigger="hover"
                                                                                placement="top"
                                                                                overlay={
                                                                                    <Tooltip id={`tooltip-${item.DashboardLibraryID}-${type}`} className="dashboard-library-tooltip">
                                                                                        {item.Description}
                                                                                    </Tooltip>
                                                                                }
                                                                            >
                                                                                <img src={contentShow} alt="content icon" className="content-icon" style={{ cursor: 'pointer' }} />
                                                                            </OverlayTrigger>
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            );
                                                        })
                                                    )}
                                                </Row>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        {/* <hr style={{ border: "1px solid black" }} /> */}
                                    </div>
                                );
                            })}
                        </Accordion>
                    </div>
                </div>
            </Main>

            {isModalOpen && (
                <ShareModal
                    open={isModalOpen}
                    handleClose={handleCloseModal}
                />
            )}
        </div>
    );
};

export default DashboardLibrary;



// import { Col, Dropdown, Form, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
// import Main from '../Main';
// import Download from '../MainSection/Download/Download';
// import '../../assets/css/dashboardlibrary.scss';
// import threedots from '../../assets/images/three-dot-img.svg';
// import DashboardLibraryImg1 from '../../assets/images/dashboard-library-1.png';
// import DashboardLibraryImg2 from '../../assets/images/dashboard-library-2.png';
// import DashboardLibraryImg3 from '../../assets/images/dashboard-library-3.png';
// import DashboardLibraryImg4 from '../../assets/images/dashboard-library-4.png';
// import DashboardLibraryImg5 from '../../assets/images/dashboard-library-5.png';
// import mobileImg from '../../assets/images/mobile-img.svg';
// import contentShow from '../../assets/images/content-show.svg';
// import ShareModal from './ShareModal';
// import { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import DashboardConfig from '../PowerBi/DashboardConfig';

// const DashboardLibrary = () => {
//     const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

//     const navigate = useNavigate(); // Initialize useNavigate

//     // Extract the SignInType
//     const signInType = signInDetails[0]?.SignInType;

//     // Array holding the different labels, image paths, and their corresponding routes
//     const dashboardItems = [
//         { label: 'Customer', imgSrc: DashboardLibraryImg1, route: '/dashboard' },
//         { label: 'Licence', imgSrc: DashboardLibraryImg2, route: '/licenceDashboard' },
//         { label: 'Attendance', imgSrc: DashboardLibraryImg3, route: '/attendanceDashboard' },
//         { label: 'Service Requests', imgSrc: DashboardLibraryImg4, route: '/complaintDashboard' },
//         { label: 'SLA', imgSrc: DashboardLibraryImg5, route: '/slaDashboard' },
//     ];

//     // Filter the dashboard items based on the SignInType
//     const filteredDashboardItems = dashboardItems.filter(item => {
//         if (signInType === "ClientAdmin") {
//             return item.label !== 'Customer'; // Hide Customer for ClientAdmin
//         } else if (signInType === "User") {
//             return item.label !== 'Customer' && item.label !== 'Licence'; // Hide both Customer and Licence for User
//         }
//         return true; // Show all items for other SignInTypes
//     });

//     const [isModalOpen, setIsModalOpen] = useState(false);

//     // Dynamically set the mobile view state based on the total number of items
//     const [mobileViewState, setMobileViewState] = useState(new Array(dashboardItems.length + DashboardConfig.tracking.length + DashboardConfig.summary.length + DashboardConfig.demand.length + DashboardConfig.forecasting.length).fill(false));

//     const handleOpenModal = () => {
//         setIsModalOpen(true);
//     };

//     const handleCloseModal = () => {
//         setIsModalOpen(false);
//     };

//     const handleImageClick = (item) => {
//         if (item.route) {
//             // Navigate to internal routes for dashboard items
//             navigate(item.route);
//         } else if (item.id) {
//             // Navigate to Power BI dashboard by ID
//             navigate(`/powerbi-dashboard/${item.id}`);
//         }
//     };

//     const toggleMobileView = (index) => {
//         const newState = [...mobileViewState];
//         newState[index] = !newState[index]; // Toggle the mobile view state for the selected item
//         setMobileViewState(newState);
//     };

//     const handleBack = () => {
//         navigate(-1);
//     };

//     const renderDashboardSection = (sectionItems, sectionLabel) => {
//         return (
//             <div>
//                 <label style={{ padding: "0.5rem 1.5rem" }}>{sectionLabel}</label>
//                 <Row className="dashboard-library-container">
//                     {sectionItems.map((item, index) => (
//                         <Col md={3} key={index} className="dashboard-library-col">
//                             <div className="dashboard-library-div">
//                                 <Form.Group>
//                                     <Form.Check
//                                         type="radio"
//                                         id={`exampleRadio${index}`}
//                                         name="radioGroup"
//                                     />
//                                 </Form.Group>
//                                 <p>{item.label}&nbsp;
//                                     {mobileViewState[index] && <img src={mobileImg} alt="Mobile View" />}
//                                 </p>
//                                 <Dropdown align="end" className='dashboard-library-dropdown'>
//                                     <Dropdown.Toggle as="div" className="dropdown-toggle">
//                                         <img src={threedots} alt="options" />
//                                     </Dropdown.Toggle>
//                                     <Dropdown.Menu>
//                                         <Dropdown.Item onClick={() => toggleMobileView(index)}>
//                                             {mobileViewState[index] ? 'Remove Mobile View' : 'Set Mobile View'}
//                                         </Dropdown.Item>
//                                         <Dropdown.Item onClick={handleOpenModal}>
//                                             Share
//                                         </Dropdown.Item>
//                                     </Dropdown.Menu>
//                                 </Dropdown>
//                             </div>
//                             <hr />
//                             <div className='dashboard-library-img'>
//                                 <img
//                                     src={item.imgSrc}
//                                     alt={item.label}
//                                     className="library-img"
//                                     onClick={() => handleImageClick(item)}
//                                 />
//                                 <OverlayTrigger
//                                     trigger="hover"
//                                     placement="top"
//                                     overlay={
//                                         <Tooltip id={`tooltip-${index}`} className="dashboard-library-tooltip">
//                                             {item.description}
//                                         </Tooltip>
//                                     }
//                                 >
//                                     <img
//                                         src={contentShow}
//                                         alt="content show"
//                                         className='content-icon'
//                                         style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
//                                     />
//                                 </OverlayTrigger>
//                             </div>
//                         </Col>
//                     ))}
//                 </Row>
//             </div>
//         );
//     };

//     return (
//         <div className="customer-management-container">
//             <Main>
//                 <div className='components-download-container'>
//                     <Download
//                         showBackButton={true}
//                         moduleName="Dashboard Library"
//                         onBackClick={handleBack}
//                     />
//                     {/* Render each section with its label */}
//                     {renderDashboardSection(filteredDashboardItems, 'Dashboard Items')}
//                     <hr style={{ border: "1px solid black", margin: "10px" }} />
//                     {renderDashboardSection(DashboardConfig.tracking, 'Tracking Reports')}
//                     <hr style={{ border: "1px solid black", margin: "10px" }} />
//                     {renderDashboardSection(DashboardConfig.summary, 'Summary Reports')}
//                     <hr style={{ border: "1px solid black", margin: "10px" }} />
//                     {renderDashboardSection(DashboardConfig.demand, 'Demand Reports')}
//                     <hr style={{ border: "1px solid black", margin: "10px" }} />
//                     {renderDashboardSection(DashboardConfig.forecasting, 'Forecasting Reports')}
//                 </div>
//             </Main>
//             {
//                 isModalOpen && <ShareModal
//                     open={isModalOpen}
//                     handleClose={handleCloseModal}
//                 />
//             }
//         </div>
//     );
// };

// export default DashboardLibrary;


